export default __webpack_public_path__ + "static/media/login-password.51448c9d.svg";